import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TaskFile } from '../interface/taskFile.interface';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class TaskCaseFileService {
  readonly baseUrl = `${this.env.URL_API_V1}/taskFile`;

  constructor(private readonly http: HttpClient, private env: EnvService) {}

  filterData = new Subject();

  createTaskFile(taskFile) {
    return this.http.post<TaskFile[]>(`${this.baseUrl}/create`, taskFile);
  }

  getAllTaskFile(id) {
    return this.http.get<TaskFile[]>(`${this.baseUrl}/getAll/${id}`);
  }

  deleteTaskFile(id) {
    return this.http.delete<TaskFile[]>(`${this.baseUrl}/delete/${id}`);
  }
}
